import { ICON_COLOR, PlusSmallIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { CLASSROOM_ROUTES } from '@/shared/constants/routes';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
import { openClassroomTab } from '../utils';
export function CreateClassroomButton({
  className,
  onBeforeOpenClassroom
}: {
  className?: string;
  onBeforeOpenClassroom?: () => void;
}) {
  const {
    t
  } = useTranslation(['common']);
  return <div className={cn('relative z-0 flex h-[103px] flex-col items-center border-b border-alternative', className)} data-sentry-component="CreateClassroomButton" data-sentry-source-file="CreateClassroomButton.tsx">
      <button type="button" onClick={() => {
      onBeforeOpenClassroom?.();
      openClassroomTab(CLASSROOM_ROUTES.list());
    }} className="group flex h-full w-full flex-col items-center gap-sm rounded-lg px-2xs py-xs transition-colors hover:bg-gray-50 mobile-lg:py-sm">
        <Button asChild variant="outlined" intent="neutral" size="lg" rounded="full" className="pointer-events-none aspect-square p-0 group-hover:bg-opacity-black-1" aria-hidden="true" data-sentry-element="Button" data-sentry-source-file="CreateClassroomButton.tsx">
          <span>
            <PlusSmallIcon size="lg" fill={ICON_COLOR.neutral} data-sentry-element="PlusSmallIcon" data-sentry-source-file="CreateClassroomButton.tsx" />
          </span>
        </Button>
        <p className="w-full truncate text-center text-body-sm-semibold text-neutral">
          {t('common:classroomLink.createClassroomButton')}
        </p>
      </button>
    </div>;
}